// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"header-wrapper__VUCNj","section-header":"section-header__14KwK","arrow-left":"arrow-left__314Zu","lesson-title":"lesson-title__y8xi_","title":"title__16oUc"};